import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CollapsibleSimple, Icon } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import cls from './TurnError.module.css';
export const TurnError = withGame(function TurnError({ showReset, renderError = (error) => error.message, gameSuite: suite, ...props }) {
    const err = suite.turnError;
    return (_jsx(CollapsibleSimple, { open: !!err, children: _jsxs(Box, { items: "center", ...props, children: [err && renderError(err), showReset && (_jsxs(Button, { color: "attention", emphasis: "ghost", onClick: () => suite.prepareTurn(null), className: cls.resetButton, children: [_jsx(Icon, { name: "refresh" }), " Reset"] }))] }) }));
});
//# sourceMappingURL=TurnError.js.map